import React from "react";
import StatisticTable from "../StatisticTable";
import {ReactHighcharts} from "../../../../lib/react-highcharts";

const UnknownLabel = "Не определено";

export const PieChart = ({data, limit = 5}) => {
    if (!(data instanceof Array)) {
        return null;
    }

    const chartData = data.slice(0, limit);
    if(data.length > limit) {
        chartData.push({
            name: 'Остальные',
            count: data.slice(limit).reduce((last, cur) => last + parseInt(cur.count), 0)
        });
    }

    const chartConfig = {
        accessibility: {
            enabled: false,
        },
        credits: {enabled: false},
        chart: {width: 240, height: 240, spacing: [0, 0, 0, 0]},
        title: {text: ''},
        plotOptions: {
            pie: {
                cursor: 'pointer',
                dataLabels: {enabled: false},
                showInLegend: true
            }
        },
        legend: {
            enabled: false
        },
        series: [{
            type: 'pie',
            name: 'Зрителей',
            data: chartData.map(item => [item.name || UnknownLabel, parseInt(item.count)])
        }]
    };

    return (
        <ReactHighcharts config={chartConfig} />
    );
};

export default (props) => {
    return (
        <table width="100%" cellSpacing={0} cellPadding={0} border={0}>
            <tbody>
            <tr>
                <td width={240} valign="top">
                    <PieChart data={props.data} />
                </td>
                <td valign="top">
                    <StatisticTable {...props} />
                </td>
            </tr>
            </tbody>
        </table>
    );
};
